import { createContext } from "react";

// useContext 跨元件傳遞
export const MessageContext = createContext({})

export const initState = {
  type: '',
  title: '',
  text: '',
};

// Reducer
export const messageReducer = (state, action) => {
  switch (action.type) {
    case "POST_MESSAGE":
      return {
        ...action.payload
      };
    case "CLEAR_MESSAGE":
      return {
        ...initState,
      };
    default:
      return state;
  }
}

export function handleSuccessMessage(dispatch,title) {
  dispatch({
    type: 'POST_MESSAGE',
    payload: {
      type: 'success',
      title: title,
    },
  });
  setTimeout(() => {
    dispatch({
      type: 'CLEAR_MESSAGE',
    });
  }, 3000);
}

export function handleErrorMessage(dispatch,title) {
  dispatch({
    type: 'POST_MESSAGE',
    payload: {
      type: 'danger',
      title: title,
    },
  });
  setTimeout(() => {
    dispatch({
      type: 'CLEAR_MESSAGE',
    });
  }, 4000);
}